import type { ComponentType } from "react";
import { Component } from "react";

import { connect } from "react-redux";

import { showErrorToast, showSuccessToast } from "app/actions/toast_actions";
import { FaviconButton } from "app/components/React/FavIcon/FaviconButton";
import { getToastItemComponent } from "app/components/React/Toast/ToastItem";
import { i18nFilter } from "app/filters/i18nFilter";
import { FavoritesService } from "app/services/favorites/favoritesService";
import { SwTrack } from "app/services/SwTrack";

interface IFaviconButtonContainerProps {
    showSuccess?: any;
    showError?: any;
    hoverMessages?: any;
    trackEventName?: string;
}

interface IFaviconButtonContainerState {
    isCurrentPageFavorite?: boolean;
}

class ButtonContainer extends Component<IFaviconButtonContainerProps, IFaviconButtonContainerState> {
    constructor(props) {
        super(props);

        this.state = {
            isCurrentPageFavorite: false,
        };
    }

    async componentDidMount() {
        const isCurrentPageFavorite = await FavoritesService.isCurrentPageFavorite();
        this.setState({ isCurrentPageFavorite });
    }

    public render() {
        return (
            <FaviconButton
                isPageFavorite={this.state.isCurrentPageFavorite}
                hoverMessages={this.props.hoverMessages}
                onFavoriteClick={this.toggleFavoritesPage}
            />
        );
    }

    private toggleFavoritesPage = () => {
        const { addSuccessToastMessage, addErrorToastMessage, removeSuccessToastMessage, removeErrorToastMessage } =
            this.props.hoverMessages;
        const showSuccess = this.props.showSuccess;
        const showError = this.props.showError;
        this.trackFavoritesClickEvent();

        if (!this.state.isCurrentPageFavorite) {
            try {
                FavoritesService.addCurrentPageToFavorites();
                this.setState({ isCurrentPageFavorite: true });
                showSuccess(i18nFilter()(addSuccessToastMessage));
            } catch (error) {
                this.setState({ isCurrentPageFavorite: false });
                showError(i18nFilter()(addErrorToastMessage));
            }
        } else if (this.state.isCurrentPageFavorite) {
            try {
                FavoritesService.removeCurrentPageFromFavorites();
                this.setState({ isCurrentPageFavorite: false });
                showSuccess(i18nFilter()(removeSuccessToastMessage));
            } catch (error) {
                this.setState({ isCurrentPageFavorite: true });
                showError(i18nFilter()(removeErrorToastMessage));
            }
        }
    };

    private buildTrackName = () => {
        const isPageFavorite = this.state.isCurrentPageFavorite;
        return `${!isPageFavorite ? "Add" : "Remove "} + ${this.props.trackEventName}`;
    };

    private trackFavoritesClickEvent = () => {
        SwTrack.all.trackEvent("Favorites", "click", this.buildTrackName());
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        showSuccess: (text?: string, linkText?: string, href?: string) =>
            dispatch(
                showSuccessToast(
                    getToastItemComponent({
                        text,
                        linkText,
                        href,
                    }),
                ),
            ),
        showError: (text?: string) => dispatch(showErrorToast(text)),
    };
};

const mapStateToProps = (store) => {
    // triggers render when page was changed
    const key = store?.routing?.params?.key || store?.routing?.params?.appId || "";
    return {
        key,
    };
};

export const FaviconButtonContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(ButtonContainer) as ComponentType<any>;
